import { FilterList } from "@mui/icons-material";
import { DatePicker } from "@mui/lab";
import {
  Badge,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  Modal,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Autocomplete
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "../../CustomAxios";
import { debounce } from "lodash";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ChalanFilter({
  bill,
  setBill,
  setSelectedCompany,
  selectedCompany,
  apCompanies,
  createdDateFrom,
  setCreatedDateFrom,
  createdDateTo,
  setCreatedDateTo,
  setFilter,
  leftDelivery,
  setLeftDelivery,
  clientAccept,
  setClientAccept,
  selectedApCompany,
  setSelectedApCompany,
}) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [customerCompanies, setCustomerCompanies] = useState([]);
  const [apCompaniesList, setApCompaniesList] = useState([]);
  const [searchCustomerCompany, setSearchCustomerCompany] = useState("");
  const [searchApCompany, setSearchApCompany] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFilter(true);
  };

  const resetFilters = () => {
    setSelectedCompany("");
    setCreatedDateFrom("");
    setCreatedDateTo("");
    setBill(null);
    setLeftDelivery(null);
    setClientAccept(null);
    setSelectedApCompany("");
  };

  useEffect(() => {
    let totalCount = 0;
    if (typeof bill === "string") {
      totalCount++;
    }
    if (typeof clientAccept === "string") {
      totalCount++;
    }
    if (typeof leftDelivery === "string") {
      totalCount++;
    }
    if (selectedCompany) {
      totalCount++;
    }
    if (selectedApCompany) {
      totalCount++;
    }
    if (createdDateFrom) {
      totalCount++;
    }
    if (createdDateTo) {
      totalCount++;
    }
    setCount(totalCount);
  }, [bill, selectedCompany, selectedApCompany, createdDateFrom, createdDateTo, clientAccept, leftDelivery]);

  const fetchCompanies = async (search, type) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };

      const url = type === "customer"
        ? `/api/v1/${userData?.type}/customer_company?limit=5&search_keyword=${search}`
        : `/api/v1/${userData?.type}/ap_company?limit=5&search_keyword=${search}`;

      const { data } = await axios.get(url, config);
      if (data.success) {
        if (type === "customer") {
          setCustomerCompanies(data.data.data);
        } else {
          setApCompaniesList(data.data.data);
        }
      }
    } catch (e) {
      console.log("error in fetching companies", e);
    }
  };

  const debouncedFetchCompanies = debounce((search, type) => {
    fetchCompanies(search, type);
  }, 300);

  useEffect(() => {
    fetchCompanies("", "customer");
    fetchCompanies("", "ap");
  }, []);

  useEffect(() => {
    if (searchCustomerCompany) {
      debouncedFetchCompanies(searchCustomerCompany, "customer");
    } else {
      fetchCompanies("", "customer");
    }
  }, [searchCustomerCompany]);

  useEffect(() => {
    if (searchApCompany) {
      debouncedFetchCompanies(searchApCompany, "ap");
    } else {
      fetchCompanies("", "ap");
    }
  }, [searchApCompany]);

  const authData = JSON.parse(localStorage.getItem("AuthData"));
  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      <Modal open={open} onClose={handleClose}>
        <Card sx={style} style={{ width: "500px" }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                {authData?.type !== "customer_user" ? (
                  <>
                    <Grid item xs={12} md={12} lg={12}>
                      <Autocomplete
                        options={customerCompanies}
                        getOptionLabel={(option) => option.name}
                        filterOptions={(options, { inputValue }) => {
                          if (!inputValue) return options;
                          const searchTerm = inputValue.toLowerCase();
                          return options.filter((option) =>
                            option.name.toLowerCase().includes(searchTerm)
                          );
                        }}
                        value={customerCompanies.find((c) => c._id === selectedCompany) || null}
                        onChange={(e, newValue) => setSelectedCompany(newValue?._id || "")}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Customer Company"
                            placeholder="Search customer companies..."
                            variant="outlined"
                            onChange={(e) => setSearchCustomerCompany(e.target.value)}
                          />
                        )}
                        fullWidth
                        sx={{
                          "& .MuiAutocomplete-listbox": {
                            maxHeight: 200,
                          },
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={12} lg={12}>
                      <Autocomplete
                        options={apCompaniesList}
                        getOptionLabel={(option) => option.name}
                        filterOptions={(options, { inputValue }) => {
                          if (!inputValue) return options;
                          const searchTerm = inputValue.toLowerCase();
                          return options.filter((option) =>
                            option.name.toLowerCase().includes(searchTerm)
                          );
                        }}
                        value={apCompaniesList.find((c) => c._id === selectedApCompany) || null}
                        onChange={(e, newValue) => setSelectedApCompany(newValue?._id || "")}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select AP Company"
                            placeholder="Search AP companies..."
                            variant="outlined"
                            onChange={(e) => setSearchApCompany(e.target.value)}
                          />
                        )}
                        fullWidth
                        sx={{
                          "& .MuiAutocomplete-listbox": {
                            maxHeight: 200,
                          },
                        }}
                      />
                    </Grid>
                  </>
                ) : null}
                <Grid item xs={4} md={4} lg={4}>
                  <div style={{ borderRight: "1px solid #808080" }}>
                    <Typography variant="h6">Left for Delivery</Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={leftDelivery === "YES"}
                          onChange={(e) => setLeftDelivery("YES")}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={leftDelivery === "NO"}
                          onChange={(e) => setLeftDelivery("NO")}
                        />
                      }
                      label="No"
                    />
                  </div>
                </Grid>
                <Grid item xs={4} md={4} lg={4}>
                  <div style={{ borderRight: "1px solid #808080" }}>
                    <Typography variant="h6">Client Accept</Typography>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={clientAccept === "YES"}
                          onChange={(e) => setClientAccept("YES")}
                        />
                      }
                      label="Yes"
                    />
                    <br />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={clientAccept === "NO"}
                          onChange={(e) => setClientAccept("NO")}
                        />
                      }
                      label="No"
                    />
                  </div>
                </Grid>
                <Grid item xs={4} md={4} lg={4}>
                  <Typography variant="h6">Bill Created</Typography>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={bill === "YES"}
                        onChange={(e) => setBill("YES")}
                      />
                    }
                    label="Yes"
                  />
                  <br />
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={bill === "NO"}
                        onChange={(e) => setBill("NO")}
                      />
                    }
                    label="No"
                  />
                </Grid>

                <Grid item xs={6} md={6} lg={6}>
                  <FormControl fullWidth>
                    <DatePicker
                      name="created_date_from"
                      format="YYYY-MM-DD"
                      renderInput={(props) => <TextField {...props} />}
                      label="Challan Created From"
                      value={createdDateFrom || null}
                      onChange={(newValue) => {
                        let selectedDate = newValue;
                        var month = (
                          "0" + parseInt(selectedDate?.getMonth() + 1)
                        ).slice(-2);
                        var day = (
                          "0" + parseInt(selectedDate?.getDate())
                        ).slice(-2);
                        let date =
                          selectedDate?.getFullYear() + "-" + month + "-" + day;
                        setCreatedDateFrom(date);
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={6} md={6} lg={6}>
                  <FormControl fullWidth>
                    <DatePicker
                      name="created_date_to"
                      format="YYYY-MM-DD"
                      renderInput={(props) => <TextField {...props} />}
                      label="Challan Created To"
                      value={createdDateTo || null}
                      onChange={(newValue) => {
                        let selectedDate = newValue;
                        var month = (
                          "0" + parseInt(selectedDate?.getMonth() + 1)
                        ).slice(-2);
                        var day = (
                          "0" + parseInt(selectedDate?.getDate())
                        ).slice(-2);
                        let date =
                          selectedDate?.getFullYear() + "-" + month + "-" + day;
                        setCreatedDateTo(date);
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={resetFilters} color="error">
                    Reset All Filter
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent={"flex-end"}
                  item
                  xs={12}
                  md={6}
                  lg={6}
                >
                  <Button onClick={handleClose} color="success">
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default ChalanFilter;